import { ColDef } from '@ag-grid-community/core';

export const ACTION_COLUMN = "ACTIONS";

export const CHECKBOX_COLUMN: ColDef = {
  headerCheckboxSelection: true,
  checkboxSelection: true,
  headerName: ' ',
  maxWidth: 75,
  filter: false,
  sortable: false,
  menuTabs: [],
  pinned: true,
  headerCheckboxSelectionFilteredOnly: true
}
